module.exports = __webpack_public_path__ + "img/img2.ce6f9a68.svg";